<template>
    <v-container class="pa-5" fluid>
        <TradersMarkUpDialog
            :is-open="tradersMarkUpDialog"
            :traders-mark-up-data="currentTradersMarkUp"
            @on-confirm="getTradersMarkUps"
            @on-close="closeTradersMarkUpDialog"
        />
        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Narzut handlowca</page-title>
            </v-col>
            <v-col cols="auto">
                <SelectMenu />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="tradersMarkUps"
                        :loading="tradersMarkUpsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="tradersMarkUpData"
                        @pagination="updatePagination"
                    >
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.value="{item}">
                            {{ item.value }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditTradersMarkUpDialog(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import SelectMenu from '@/views/Configurations/CalculationsCosts/Common/SelectMenu'
import TradersMarkUpDialog from './TradersMarkUpDialog'


export default {
    name: 'TradersMarkUp',
    components: {
        PageTitle,
        SelectMenu,
        TradersMarkUpDialog
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay
    ],
    data() {
        return {
            currentTradersMarkUp: {},
            tradersMarkUpDialog: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Narzut %',
                    value: 'value',
                    sortable: false,
                    width: 250
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        tradersMarkUps() {
            return this.$store.state.configurations.calculationsCosts.tradersMarkUps.tradersMarkUps
        },
        tradersMarkUpsLoading() {
            return this.$store.state.configurations.calculationsCosts.tradersMarkUps.tradersMarkUpsLoading
        },
        savedFilters() {
            return this.$store.state.configurations.calculationsCosts.tradersMarkUps.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getTradersMarkUps()
    },
    methods: {
        getTradersMarkUps() {
            this.$store.dispatch('configurations/calculationsCosts/getTradersMarkUps', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showEditTradersMarkUpDialog(tradersMarkUp) {
            this.currentTradersMarkUp = tradersMarkUp
            this.tradersMarkUpDialog = true
        },
        closeTradersMarkUpDialog() {
            this.tradersMarkUpDialog = false

            setTimeout(() => {
                this.currentTradersMarkUp = {}
            }, 500)
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getTradersMarkUps()
            }
            this.clearPaginationPending()
        },
    }
}
</script>